import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import AuthContext from './AuthContext';

const PublicRoute = ({ children }) => {
  const {
    loading,
    user,
  } = useContext(AuthContext);

  if (loading) {
    return null;
  }

  if (user) {
    return (
      <Navigate
        to="/opportunity-calculator"
        replace
      />
    );
  }

  return children;
};

export default PublicRoute;